<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
import upload from "@/components/upload.vue";
import { verifyField } from "@/common/utils";
import tant from "@/components/tant.vue";

export default {
    components: { upload, tant },
    data() {
        return {
            form: {},
            verifyRules: {
                shiquanCoin: [
                    { required: true, message: "请输入积分发放数量" },
                    {
                        validator: (val) => +val >= 0,
                        message: "请输入大于等于0的积分发放数量",
                    },
                ],
                reason: [
                    { required: true, message: "请输入奖励原因" },
                ],
                grantTime: [
                    { required: true, message: "请选择发放时间" },
                ],
            },
            pageType: "",
            commonTopData:{
                pageName:"选择发放用户",
                commonleftbtn:[
                    {name:"筛选",fun: "ISshow",is:1,img:require("@/assets/img/icon_sx.svg")},
                    {name:'字段显示',fun: "ISfield",is:2,img:require("@/assets/img/show_icon.svg")},
                ],
                commonrightbtn:[],
                commonbottombtn:[],
                tabTopData:[],
                tabnums:0,
            },
            screenConfig:[],
            tableConfig:{
                url:"getUserList",
                list: [
                    {label:"用户ID",prop:"open_id"},
                    {label:"用户头像",prop:"avatar",type:"img"},
                    {label:"用户昵称",prop:"username"},
                    {label:"手机号",prop:"mobile"},
                    {label:"邮箱",prop:"email"},
                    {label:"性别",prop:"sex",type:"keyvalue",child:{"1":"男","2":"女","0":"无"}},
                    {label:"职业",prop:"vocation",type:"keyvalue",child:{"1":"上架","-1":"下架"}},  
                    {label:"所在地",prop:"address"},
                    {label:"作品数量",prop:"work_num"},
                    {label:"关注人数",prop:"follow_num"},
                    {label:"粉丝人数",prop:"fans_num"},
                ],
                ischeck: true,
            },
            filterFields:{
                filterFields:[
                    {name:"用户ID",id:"open_id"},
                    {name:"用户昵称",id:"username"},
                    {name:"手机号",id:"mobile"},
                    {name:"邮箱",id:"email"},	
                    {name:"性别",id:"sex",type:'select',child:[{value:'1',label:'男'},{value:'2',label:'女'},{value:'0',label:'无'}]},
                    {name:"职业",id:"vocation",type:'select',child:[{value:'1',label:'插画师'},{value:'2',label:'作家'}]},  
                    {name:"所在地",id:"address"},
                    {name:"作品数量",id:"work_num"},
                    {name:"关注人数",id:"follow_num"},
                    {name:"粉丝人数",id:"fans_num"},	
                ],
            },
            //需要展示的字段
            defaults:[
                'open_id', 'avatar', 'username', 'mobile', 'email', 'sex', 'vocation', 'address',
                'work_num', 'follow_num', 'fans_num'
            ],
            tan: false,
            dataList: [],
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;  //如果没有后面的-8.64e7就是不可以选择今天的 
                }
            },
        };
    },
    methods: {
        //操作字段筛选的回显
        isShowBtn(data,list){
            this.defaults = data
            let arr = [];
            if(list.length > 0){
                list.forEach(item => {
                    data.forEach(da => {
                        if(item.prop == da){
                            arr.push(item)
                        }
                    })
                })
            }
            this.tableConfig.list = arr;
        },
        init() {
            this.pageType = this.$route.query.pageType;

            if (this.pageType === "view" || this.pageType === "modify") {
                this.getPrizeDetail();
            }
        },
        async getPrizeDetail() {
            let id = this.$route.query.id;
            let data = await this.api.pointsystemGrandDetail({
                id,
                access_token: localStorage.getItem("access_token"),
            });
            this.form = data;
            let obj = {
                avatar: data.avatar,
                username: data.username,
                open_id: data.open_id
            }
            this.dataList.push(obj)
        },
        change() {
            this.$forceUpdate()
        },
        async prizeAdd() {
            if(this.dataList.length == 0 && this.pageType !== "view"){
                this.$message({ message: '请选择发放用户', type: 'error' })
                return
            }
            let open_ids = this.dealData(this.dataList)
            this.form.open_ids = open_ids
            if (verifyField(this.verifyRules, this.form)) {
                if(!this.form.grantTime && this.pageType !== "view"){
                    this.$message({ message: '请选择发放时间', type: 'error' })
                    return
                }
                await this.api[
                    this.pageType === "modify" ? "pointsystemGrantEdit" : "pointsystemCoinGrant"
                ](
                    Object.assign(this.form, {
                        access_token: localStorage.getItem("access_token"),
                    })
                );

                if(this.pageType === 'modify') {
                    this.$message({ message: '保存成功', type: 'success' })
                }else {
                    this.$message({ message: '添加成功', type: 'success' })
                }
                this.$router.back()
            }
        },
        dealData(data) {
            if(data.length > 0){
                var str = '';
                data.forEach(item => {
                    str += item.open_id + ",";
                })
                return str.slice(0,str.length-1)
            }
        },
        hide() {
            this.tan = false;
        },
        ADDlist(data) {
            this.tan = false;
            this.dataList = data;
        },
        dele(id) {
            this.dataList.forEach((item,index)=>{
                if(item.open_id == id) {
                    this.dataList.splice(index,1);
                }
            })
        },
        choose() {
            this.tan = true;
            this.$refs.Tabledd.change(this.dataList);
        },
    },
    created() {
        this.init();
    },
};
</script>
